import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import type { LocationRecord } from '#shared/cms/records'

type LocationValue = Omit<LocationRecord, '$type'>

interface LocationEntry {
  rkey: string
  uri: string
  cid: string
  value: LocationRecord
}


export default /*@__PURE__*/_defineComponent({
  __name: 'location',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'Location - admin - Daniel Roe' })

const { data, refresh, loading } = useAdminFetch<LocationEntry | null>('/api/admin/location')

async function save (value: LocationValue) {
  await $fetch('/api/admin/location', {
    method: 'PUT',
    body: value,
  })
  await refresh()
}

return (_ctx: any,_cache: any) => {
  const _component_AdminSkeletonForm = _resolveComponent("AdminSkeletonForm")!
  const _component_AdminLocationForm = _resolveComponent("AdminLocationForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "Location" }, {
    default: _withCtx(() => [
      (_unref(data) === undefined && _unref(loading))
        ? (_openBlock(), _createBlock(_component_AdminSkeletonForm, {
            key: 0,
            fields: ['pair', 'pair', 'checkbox']
          }))
        : (_openBlock(), _createBlock(_component_AdminLocationForm, {
            key: 1,
            initial: _unref(data)?.value,
            onSubmit: save
          }, null, 8, ["initial"]))
    ]),
    _: 1
  }))
}
}

})